import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../../utilities/TabGrid";
import TopIf from "../../../../../../componentsTopsa/if/TopIf";

export default class SprawdzKonfiguraceWszystkieTrasyTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.formatDane = this.formatDane.bind(this)
        this.formatDaneRozklad = this.formatDaneRozklad.bind(this)
        this.expandComponent = this.expandComponent.bind(this)
    }

    czyMinelaJuzData(data){
        let now = new Date().toJSON().substr(0,10)
        return(now>data)
    }

    formatDane(cell, row, typ = 'string') {
        if (cell === true) {
            return (<div style={(this.czyMinelaJuzData(row.data))?{opacity:'0.6'}:{}}><i style={{color: 'forestgreen'}} className={'fa fa-check'}></i> tak</div>)
        }
        else {
            return (<div style={(this.czyMinelaJuzData(row.data))?{opacity:'0.6'}:{}}><i style={{color: 'firebrick'}} className={'fa fa-times'}></i> nie</div>)
        }
    }

    formatDaneRozklad(cell, row, typ = 'string') {
        if (cell === true && Boolean(row.czyKalGodz)) {
            return (<div style={(this.czyMinelaJuzData(row.data))?{opacity:'0.6'}:{}}><i style={{color: 'forestgreen'}} className={'fa fa-check'}></i> tak</div>)
        }
        else {
            return (<div style={(this.czyMinelaJuzData(row.data))?{opacity:'0.6'}:{}}><i style={{color: 'firebrick'}} className={'fa fa-times'}></i> nie</div>)
        }
    }

    expandComponent(row) {

        return <div style={{borderBottom: '3px solid #83c33a', paddingBottom: '5px'}}>
            <div className={'well well-sm'} style={(this.czyMinelaJuzData(row.data))?{opacity:'0.6',marginBottom: '5px'}:{marginBottom: '5px'}}>
                <TopIf isTrue={row.trKalGodz.length > 0}>
                    <p>
                        <label>
                            Na poniższych trasach nie zdefiniowano godzin startowych:
                        </label>
                        <div>
                            {row.trKalGodz}
                        </div>
                    </p>
                </TopIf>
                <TopIf isTrue={row.trRozkl.length > 0}>
                    <p>
                        <label>
                            Na poniższych trasach nie wygenerowano rozkładu:
                        </label>
                        <div>
                            {row.trRozkl}
                        </div>
                    </p>
                </TopIf>
                <TopIf isTrue={row.trObs.length > 0}>
                    <p>
                        <label>
                            Na poniższych trasach nie wygenerowano obsady:
                        </label>
                        <div>
                            {row.trObs}
                        </div>
                    </p>
                </TopIf>

            </div>
        </div>

    }

    expandColumnComponent({isExpandableRow, isExpanded}) {
        let content = '';

        if (isExpandableRow) {
            content = (isExpanded ?
                    (<i style={{display: "block", textAlign: "center"}} className='fa fa-lg fa-caret-up'></i>)
                    :
                    (<i style={{display: "block", textAlign: "center"}} className='fa fa-lg fa-caret-down'></i>)
            )
        } else {
            content = ' ';
        }
        return (
            <div> {content} </div>
        );
    }

    isExpandableRow(row) {
        return (Boolean(row.trKalGodz) || Boolean(row.trRozkl) || Boolean(row.trObs))
    }

    render() {

        let statusy = {
            true: 'tak',
            false: 'nie'
        }

        const options = {
            noDataText: 'Brak pasujących rekordów',
            expandBy: 'column'
        };

        return (
            <div>
                <h2 style={{textAlign: 'center', margin: '30px 0'}}>
                    Wszystkie trasy
                </h2>
                <div>
                    <BootstrapTable data={this.props.data}
                                    options={options}
                                    hover
                                    expandableRow={this.isExpandableRow}
                                    expandComponent={this.expandComponent}
                                    expandColumnOptions={{
                                        expandColumnVisible: true,
                                        expandColumnComponent: this.expandColumnComponent,
                                        columnWidth: 30,
                                    }}
                    >
                        <TableHeaderColumn dataField='data' isKey hidden={true}>ID</TableHeaderColumn>
                        <TableHeaderColumn dataField='data'
                                           thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5} dataSort
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell,row)=>{
                                               return <span style={(this.czyMinelaJuzData(cell))?{opacity:'0.6'}:{}}>{cell}</span>
                                           }}
                        >Data</TableHeaderColumn>
                        <TableHeaderColumn dataField='czyKal'
                                           thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5} dataSort
                                           filter={{type: 'SelectFilter', options: statusy, selectText: 'Wybierz'}}
                                           formatExtraData={statusy}
                                           dataFormat={this.formatDane}
                        >Czy wygenerowano kalendarze do daty?</TableHeaderColumn>
                        <TableHeaderColumn dataField='czyKalGodz'
                                           thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5} dataSort
                                           filter={{type: 'SelectFilter', options: statusy, selectText: 'Wybierz'}}
                                           formatExtraData={statusy}
                                           dataFormat={this.formatDane}
                        >Czy istnieją godziny odjazdów?</TableHeaderColumn>
                        <TableHeaderColumn dataField='czyRozkl'
                                           thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5} dataSort
                                           filter={{type: 'SelectFilter', options: statusy, selectText: 'Wybierz'}}
                                           formatExtraData={statusy}
                                           dataFormat={this.formatDaneRozklad}
                        >Czy wygenerowano rozkład?</TableHeaderColumn>
                        <TableHeaderColumn dataField='czyObs'
                                           thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5} dataSort
                                           filter={{type: 'SelectFilter', options: statusy, selectText: 'Wybierz'}}
                                           formatExtraData={statusy}
                                           dataFormat={this.formatDane}
                        >Czy wygenerowano obsadę?</TableHeaderColumn>
                    </BootstrapTable>
                </div>
                {/*<div>
                    <h4>Wskazówki</h4>
                    <ul>
                        <li>
                            Jeżeli w polu <span style={{fontWeight: 'bold'}}>Czy wygenerowano kalendarze do daty?</span> znajduje się
                            wartość <i className={'fa fa-times'} style={{color: 'firebrick'}}></i>, należy sprawdzić czy przypisano kalendarz
                            do daty bądź ponowić próbę generowania kalendarzy do dat.
                            <Link target={'_blank'} to={'/konfiguracja/rozklad-jazdy/kalendarze'}> Przejdź do widoku</Link>
                        </li>
                        <li>
                            Jeżeli w polu <span style={{fontWeight: 'bold'}}>Czy istnieją godziny odjazdów?</span> znajduje się
                            wartość <i className={'fa fa-times'} style={{color: 'firebrick'}}></i> należy sprawdzić czy dla danego kalendarza istnieją
                            zdefiniowane godziny odjazdów na danej trasie.
                            <Link target={'_blank'} to={'/konfiguracja/rozklad-jazdy/godziny-startowe'}> Przejdź do widoku</Link>
                        </li>
                        <li>
                            Jeżeli w polu <span style={{fontWeight: 'bold'}}>Czy wygenerowano rozkład?</span> znajduje się
                            wartość <i className={'fa fa-times'} style={{color: 'firebrick'}}></i> należy wygenerować rozkład jazdy.
                            <Link target={'_blank'} to={'/konfiguracja/rozklad-jazdy/rozklad'}> Przejdź do widoku</Link>
                        </li>
                        <li>
                            Jeżeli w polu <span style={{fontWeight: 'bold'}}>Czy wygenerowano obsadę?</span> znajduje się
                            wartość <i className={'fa fa-times'} style={{color: 'firebrick'}}></i> należy wygenerować obsadę.
                            <Link target={'_blank'} to={'/konfiguracja/rozklad-jazdy/obsada'}> Przejdź do widoku</Link>
                        </li>
                    </ul>
                </div>*/}
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/sprawdzKonfiguracje/components/componentsRozklad/SprawdzKonfiguraceWszystkieTrasyTable.js